import {
    Button,
    Chip,
    Grid,
    makeStyles,
    MenuItem,
    Typography,
} from "@material-ui/core";
import {
    ValidatorForm,
    SelectValidator,
    TextValidator,
} from "react-material-ui-form-validator";
import "moment/locale/es";
import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "../../../hooks/useForm";
import { fetchConToken } from "../../../helpers/fetch";
import { startAlerta } from "../../../actions/ui/alertas";
import { finishSpinner, startSpinner } from "../../../actions/ui/spinner";
import { BuscadorContratoPorCod } from "./BuscadorContratoPorCod";
import Card from "@material-ui/core/Card";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";
import { useState } from "react";
import { getEfectoresPorLiquidadorPorUsuario } from "../../../actions/liquidaciones/efectoresPorLiquidador";

const useStyles = makeStyles((theme) => ({
    chip: {
        margin: theme.spacing(0.5),
    },
    root: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        listStyle: 'none',
        padding: theme.spacing(0.5),
        margin: 0,
    },
}));

export const FormLiquidador = (props) => {
    const { formData } = props
    const { liquidadores, efectoresPorLiquidador } = useSelector((state) => state.efectoresPorLiquidador);
    const { items: usuarios } = useSelector((state) => state.usuarios);

    const codigoContratoRef = useRef(null);
    const codigoContratoHastaRef = useRef(null);
    const [codContratoDesde, setCodContratoDesde] = useState(null)
    const [codContratoHasta, setCodContratoHasta] = useState(null)

    const classes = useStyles()
    const dispatch = useDispatch()

    useEffect(() => {
        if (formData){
            dispatch(getEfectoresPorLiquidadorPorUsuario(formData.idLiquidador))
        }
       
    }, [dispatch])

    const datosLiquidador = {
        idUsuario: formData ? formData.idUsuario : '',
        efectores: formData ? efectoresPorLiquidador : []
    }

    const [
        formValues,
        handleInputChange,
        ,
        setearValor,
        ,
        ,
        ,
        ,
        setearVariosValores
    ] = useForm(datosLiquidador)

    const {
        idUsuario,
        efectores,
    } = formValues;

    useEffect(() => {
        setearVariosValores({
            idUsuario: formData?.idUsuario || '',
            efectores: efectoresPorLiquidador || []
        });
    }, [efectoresPorLiquidador]);

    const handleAgregarContratos = async () => {
        if (codContratoDesde === null) {
            dispatch(startAlerta("Ingrese un Codigo Contrato Desde.", "error"));
        } else if (codContratoHasta !== null && codContratoHasta?.idEfectorFacturacion < codContratoDesde?.idEfectorFacturacion) {
            dispatch(startAlerta("El Codigo Hasta debe ser mayor al Codigo Desde.", "error"))
        } else {
            try {
                dispatch(startSpinner())
                const result = await fetchConToken(`EfectorFacturacion/BusquedaEfectores/${codContratoDesde?.idEfectorFacturacion}/${codContratoHasta?.idEfectorFacturacion}`)
                const body = await result.json()
                if (result.ok) {
                    setearVariosValores({
                        "efectores": [...efectores, ...body.filter(e => efectores.find(efector => efector.idEfectorFacturacion === e.idEfectorFacturacion) ? false : true)],
                    });
                    setCodContratoDesde(null);
                    setCodContratoHasta(null);
                    codigoContratoRef.current.resetValues();
                    codigoContratoHastaRef.current.resetValues();
                    dispatch(finishSpinner())
                } else {
                    throw body
                }
            } catch (error) {
                dispatch(finishSpinner())
                dispatch(startAlerta("Error al traer los contratos", "error"))
            }
        }
    }

    const handleSave = (e) => {
        e.preventDefault();
        if (efectores.length === 0) {
            dispatch(startAlerta("Debe agregar al menos un contrato", "error"));
        } else {
            if (formData) {
                props.handleSubmit({ idEfectores: efectores.map(ef => ef.idEfectorFacturacion), idLiquidador: formData.idLiquidador });
            } else {
                props.handleSubmit({ idUsuario, idEfectores: efectores.map(ef => ef.idEfectorFacturacion) });
            }
        }
    };

    console.log(codContratoDesde)
    
    console.log(codContratoHasta)

    
    console.log("efectores", efectores)
    return (
        <ValidatorForm onSubmit={handleSave}>
            <Grid
                container
                spacing={1}
                direction="row"
                justify="center"
                alignItems="center"
            >
                <Grid item xs={12}>
                    {formData === null
                        ?
                        <SelectValidator
                            fullWidth
                            label="Liquidador"
                            margin="normal"
                            name="idUsuario"
                            value={idUsuario}
                            validators={["required"]}
                            errorMessages={["Debe seleccionar un liquidador"]}
                            onChange={handleInputChange}
                        >
                            {
                                usuarios.filter(usuario => liquidadores.find(liquidador => usuario.idUsuario === liquidador.idUsuario) ? false : true).map((u) =>
                                    (<MenuItem key={u.idUsuario} value={u.idUsuario}>{u.userName}</MenuItem>))
                            }
                        </SelectValidator>
                        :
                        <TextValidator
                            fullWidth
                            label="Modulo"
                            defaultValue={usuarios.find(e => e.idUsuario === formData.idUsuario).userLogin}
                            disabled
                        />
                    }
                </Grid>
                <Grid item xs={11}>
                    <Grid
                        container
                        spacing={5}
                        justify="center"
                        alignItems="center"
                        component={Card}
                        style={{ marginTop: "0.5rem", marginBottom: "0.5rem" }}
                    >
                        <Grid item xs={6} style={{ marginTop: "0.5rem" }}>
                            <BuscadorContratoPorCod
                                ref={codigoContratoRef}
                                cod={codContratoDesde}
                                label="Código - Razón Social - Contrato Desde"
                                setCod={(val) => setCodContratoDesde(val)}
                            />
                        </Grid>
                        <Grid item xs={6} style={{ marginTop: "0.5rem" }}>
                            <BuscadorContratoPorCod
                                ref={codigoContratoHastaRef}
                                cod={codContratoHasta}
                                label="Código - Razón Social - Contrato Hasta"
                                setCod={(val) => setCodContratoHasta(val)}
                            />
                        </Grid>
                        <Grid item xs={12} style={{ textAlign: 'center' }}>

                            <Button
                                onClick={() => handleAgregarContratos()}
                                type="button"
                                color="primary"
                                variant="outlined"
                            >
                                + Agregar
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="button">Contratos agregados</Typography>
                    <div className={classes.root}>
                        {efectores &&
                            efectores.map((efector, index) => (
                                <Chip
                                    key={index}
                                    label={`${efector.descripcionEfector ? efector.descripcionEfector : efector.nombreFantasia } - ${efector.cuit}`}
                                    onDelete={() => setearValor("efectores", efectores.filter(e => e.idEfectorFacturacion !== efector.idEfectorFacturacion))}
                                    className={classes.chip}
                                />
                            ))
                        }
                    </div>
                </Grid>
            </Grid>
            <Grid container spacing={2} justify="flex-end">
                <Grid item>
                    <Button
                        variant="contained"
                        color="secondary"
                        size="small"
                        type="button"
                        startIcon={<CancelIcon />}
                        onClick={props.handleCancel}
                    >
                        Cancelar
                    </Button>
                </Grid>
                <Grid item>
                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        startIcon={<SaveIcon />}
                        type='submit'
                    >
                        GUARDAR
                    </Button>
                </Grid>
            </Grid>
        </ValidatorForm>
    );
};
